import moment from "moment";
import { Badge, ActionIcon, Tooltip, Group, Text } from "@mantine/core";
import {
  IconBrandWhatsapp,
  IconFileInvoice,
  IconUserDollar,
  IconCube,
  IconUser,
  IconMoneybag,
  IconArrowBigUpLine,
  IconWallet,
  IconSettings2,
  IconBox,
} from "@tabler/icons-react";
import { openWhatsapp } from "../../hooks/useCellRender";

const entityIconMap = {
  Order: IconFileInvoice,
  Client: IconUserDollar,
  Product: IconCube,
  User: IconUser,
  Commission: IconMoneybag,
  Promotion: IconArrowBigUpLine,
  Payroll: IconWallet,
};

const actionColorMap = {
  Created: "green",
  Updated: "blue",
  Deleted: "red",
};

const SnapshotCell = ({ row }) => {
  const snap = row.snapshot;
  const entityType = row.entityType;
  const Icon = entityIconMap[entityType] || IconBox;

  return (
    <Group wrap="nowrap" gap="sm">
      <Icon size={18} stroke={1.5} color="#868e96" />
      <div>
        <Group gap={6} wrap="nowrap">
          {entityType && (
            <Badge size="xs" radius={0} variant="light" color="gray">
              {entityType}
            </Badge>
          )}
          {snap?.code && (
            <Text size="xs" fw={600}>
              {snap.code}
            </Text>
          )}
          {snap?.orderCode && !snap?.code && (
            <Text size="xs" fw={600}>
              {snap.orderCode}
            </Text>
          )}
        </Group>
        {snap?.name && (
          <Text size="xs" c="dimmed" lineClamp={1}>
            {snap.name} {snap?.cname ? `(${snap.cname})` : ""}
          </Text>
        )}
        {snap?.phone && (
          <Text size="xs" c="dimmed">
            {snap.phone}
          </Text>
        )}
        {!snap && !entityType && (
          <Text size="xs" c="dimmed">
            -
          </Text>
        )}
        {!snap && entityType && (
          <Text size="xs" c="dimmed">
            {entityType}
          </Text>
        )}
      </div>
    </Group>
  );
};

export const ActivityLogTableSchema = (cellRender) => {
  return {
    showActionColumn: false,
    columns: [
      {
        field: "createdAt",
        headerName: "Date",
        sortable: true,
        cellRender: (col, row) =>
          cellRender.Date(row.createdAt, "YYYY-MM-DD HH:mm"),
      },
      {
        field: "by",
        headerName: "User",
        sortable: true,
        cellRender: (col, row) => cellRender.User(row.by),
      },
      {
        field: "title",
        headerName: "Action",
        sortable: true,
        cellRender: (col, row) => (
          <Badge
            size="xs"
            radius={0}
            color={actionColorMap[row.title] || "gray"}
          >
            {row.title}
          </Badge>
        ),
      },
      {
        field: "entityType",
        headerName: "Entity",
        sortable: true,
        cellRender: (col, row) => <SnapshotCell row={row} />,
      },
      {
        field: "description",
        headerName: "Description",
        sortable: false,
        cellRender: (col, row) => (
          <Text size="sm" c="dimmed">
            {row.description}
          </Text>
        ),
      },
      {
        field: "whatsapp",
        headerName: "WhatsApp",
        cellRender: (col, row) => {
          const phone = row.snapshot?.phone || row.by?.phone;
          if (!phone) return "-";
          return (
            <Tooltip label={`WhatsApp ${phone}`}>
              <ActionIcon
                variant="subtle"
                color="green"
                onClick={(e) => {
                  e.stopPropagation();
                  openWhatsapp(phone);
                }}
              >
                <IconBrandWhatsapp size={20} />
              </ActionIcon>
            </Tooltip>
          );
        },
      },
    ],
    searchByTextField: true,
    searchableFields: ["title", "description", "entityType"],
  };
};
